import { Trans, useLingui } from "@lingui/react/macro";
import type { BusinessDataConnection } from "../../services/businessDataConnectionService";
import type { BusinessDataOperation } from "../../services/businessDataService";
import { formatAbsoluteDate } from "../../utils/relativeTime";
import { HealthRow } from "./HealthRow";
import { ClockIcon, ItemsIcon, KeyIcon } from "./icons";

interface Props {
  conn: BusinessDataConnection;
  scanJob?: BusinessDataOperation;
}

// Panel shown when a connection's credentials failed verification (status 'error').
// Surfaces the sanitized auth error and the last successful scan (date + items, so
// the admin still sees what protection is in place) — the fix is Reconnect, in the actions.
export function ConnectionAuthError({ conn, scanJob }: Props) {
  const { t } = useLingui();
  return (
    <div className="space-y-1.5 mb-3">
      <div className="flex items-start gap-1.5 rounded-lg px-2 py-1.5 text-xs bg-red-50 dark:bg-red-500/10 text-red-600 dark:text-red-400 border border-red-200 dark:border-red-800/40">
        <KeyIcon className="w-3.5 h-3.5 flex-shrink-0 mt-px" />
        <span className="line-clamp-2" title={conn.lastError || undefined}>
          {conn.lastError || <Trans>Authentication failed — reconnect to update credentials.</Trans>}
        </span>
      </div>
      {scanJob?.lastSuccessAt && (
        <>
          <HealthRow
            Icon={ClockIcon}
            label={t`Last good scan`}
            value={formatAbsoluteDate(scanJob.lastSuccessAt)}
            valueTitle={scanJob.lastSuccessAt || undefined}
          />
          {scanJob.lastSuccessItems != null && <HealthRow Icon={ItemsIcon} label={t`Items indexed`} value={scanJob.lastSuccessItems.toLocaleString()} />}
        </>
      )}
    </div>
  );
}
